module.exports = __webpack_public_path__ + "static/media/2_r_hadphons_92.81_2.96.b69163fa.png";